<div class="three-items">
    <p>{{phoneNumber}}</p>
    <a [href]="'https://wa.me/' + phoneNumber" target="_whatsapp"><img src="assets/icons/whatsapp.png" /></a>
    <a [href]="'tel://' + phoneNumber"><img src="assets/icons/telephone-call.png"></a>
</div>